// export { default as masthead } from './modules/masthead.js';
// export { SectionNav } from './modules/section-nav.js';
// export * as share from './modules/share.js';
// export * as links from './modules/links.js';
// export * as fitvid from './modules/fitvid.js';
// export * as fetch from './modules/fetch.js';
export * as scrollbarWidth from './modules/scrollbar-width.js';
export const blocks = {}; // this is necessary for webpack's export modules - see webpack.config.js
